import * as Glob from "../../../Globale";
import * as Dati from "../../../Dati";
import * as DatiFide from "../../../DatiFide";
import {Trad} from "../../../components";

export const onPrint = (bozza: boolean, policy: Dati.CDatiPolizza, signature: boolean, marca: boolean, numAddendum: number) => {
    let CoAss: Dati.CDatoCoAssicurazione[] = [];
    CoAss = JSON.parse(policy.CoAssicurazioneJSON);

    let ID_BinderCompagnia: number = 0;
    for (let i: number = 0; i < CoAss.length; i++) {
        if (CoAss[i].Delegataria) {
            ID_BinderCompagnia = CoAss[i].ID_BinderCompagnia;
        }
    }
    
    let fileInfo = new Dati.CDatiRequestPolicyFileBond()
    fileInfo.ID_Polizza = numAddendum > 0 
        ? policy.ID_Polizza * 10 **  numAddendum.toString().length + numAddendum 
        : policy.ID_Polizza
    fileInfo.Polizza = policy.Polizza
    fileInfo.ID_TipoProdotto = policy.ID_TipoProdotto
    fileInfo.TipoProdotto = policy.TipoProdotto
    fileInfo.ID_BinderCompagnia = ID_BinderCompagnia
    fileInfo.ID_TipoPolizzaStato = policy.ID_TipoPolizzaStato
    //fileInfo.ID_ModalitaEmissione = policy.id_
    fileInfo.uri = URL + "-O"
    fileInfo.namePolicy =  fileInfo.ID_Polizza +  (numAddendum > 0 ? '.' + numAddendum : '') + '_' + policy.TipoProdotto
    fileInfo.useSignature = signature
    fileInfo.useSignatureTimestamp = marca
    return fileInfo
};
export const onPrintCoobligated = (
    idPolicy: string, 
    coobligated: DatiFide.CDatiFideCoobbligato[], 
    coAssicurazioneJSON: string, 
    isTemplate: boolean = false) => 
{
    let database: string = Glob.StampaDatabase();
    let baseUrl: string = Glob.StampaURL();

    baseUrl += "?SessioneMyAr=" + Glob.GetSessione().Sessione;
    baseUrl += "&Database=" + database;
    baseUrl += "&Data=" + Date.now();
    baseUrl += "&Tipo=" + "COOB-";

    let coAssicurazione: Dati.CDatoCoAssicurazione[] = [];
    coAssicurazione = JSON.parse(coAssicurazioneJSON);

    let ID_BinderCompagnia: number = 0;
    for (let i: number = 0; i < coAssicurazione.length; i++) {
        if (coAssicurazione[i].Delegataria) {
            ID_BinderCompagnia = coAssicurazione[i].ID_BinderCompagnia;
        }
    }
    
    for (let i: number = 0; i < coobligated.length; i++) {
        let url: string = baseUrl;
        if (coobligated[i].Quota >= 100) {
            if (coobligated[i].ID_TipoAnagPrincipale === "TAP-PersonaFisica")
                url += "FISICA"
            else
                url += "GIURIDICA";
        }
        else
            url += "GIURIDICAPQ";
        
        url += "-" + ID_BinderCompagnia + "-PDF";
        url += "&Chiave=" + idPolicy;
        url += "&Chiave2=" + coobligated[i].ID_Anag;
        
        if (isTemplate)
            url += "&Word=true";
        
        url += "&NomeFile=Coobligated" + i.toString();
        window.open(url, "_blank", "location=yes,height=600,width=800,scrollbars=yes,status=yes");
    }
};

export const onClickPrint = (dati: Dati.CRisAPI) => {
    let IsSigned = false;
    if (dati.Errore) {
        Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
    } else {
        for (let i: number = 0; i < dati.MessaggioDati.length; i++) {
            DownloadPolicyFile(dati.MessaggioDati[i]);
            if (dati.MessaggioDati[i].IdSignRequest !== "00000000-0000-0000-0000-000000000000")
                IsSigned = true;
        }
        if (IsSigned)
        {
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.TradParam("Polizza firmata correttamente con ID: {1-S}", [dati.ID_Chiave]));
            window.location.reload();
        }
    }
}

const DownloadPolicyFile = (data: Dati.CDatiPolicyFile) => {
    if (data.Data != "" && data.Data != undefined) {
        const linkSource = `data:application/pdf;base64,${data.Data}`;
        const downloadLink = document.createElement("a");
        const fileName = `${data.FileName}`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        downloadLink.remove();
    }
};


// WEBPACK FOOTER //
// ./src/inar2/components/Bond/helpers.ts